// Function to get currency symbol based on currency code
export const getCurrencySymbol = (currencyCode) => {
  const symbols = {
    'USD': '$',
    'EUR': '€',
    'GBP': '£',
    'CAD': 'C$',
    'AUD': 'A$',
    'JPY': '¥',
    'CHF': 'Fr',
    'CNY': '¥',
    'INR': '₹',
    'BRL': 'R$',
    'MXN': '$',
    'SGD': 'S$',
    'NZD': 'NZ$',
    'HKD': 'HK$',
    'SEK': 'kr',
    'NOK': 'kr',
    'DKK': 'kr',
    'ZAR': 'R',
    'RUB': '₽',
    'AED': 'dh'
  };
  
  return symbols[currencyCode] || '$'; // Default to $ if currency not found
};